@if (hasControl()) {
  <form [formGroup]="fG">
    <ejs-checkbox
      [formControlName]="fCN"
      [labelPosition]="labelPosition"
      [value]="value"
      [label]="label"
      [checked]="checked"
      [cssClass]="cssClass + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? ' e-error' : '')"
    ></ejs-checkbox>
    <ng-content />
  </form>
} @else {
  <ejs-checkbox
    [labelPosition]="labelPosition"
    [value]="value"
    [label]="label"
    [checked]="checked"
    [disabled]="disabled"
    [cssClass]="cssClass"
    (change)="onStandaloneChange($event)"
  ></ejs-checkbox>
  <ng-content />
}
